import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { LimitType, type AddLimitFormFields } from 'types/paymentLimits'
import { AMOUNT_VALIDATION_PATTERN } from 'utils/yupSchemas/createNameSchema'

export const addLimitSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Record<keyof AddLimitFormFields, yup.AnySchema>>({
    currency: yup.string().required(
      t('fieldIsARequiredField', {
        field: t('paymentLimits.currency'),
        interpolation: { escapeValue: false },
      })
    ),
    method: yup.string().required(
      t('fieldIsARequiredField', {
        field: t('paymentLimits.paymentMethod'),
        interpolation: { escapeValue: false },
      })
    ),
    limitType: yup
      .string()
      .oneOf(Object.values(LimitType))
      .required(
        t('fieldIsARequiredField', {
          field: t('paymentLimits.limitTypeLabel'),
          interpolation: { escapeValue: false },
        })
      ),
    amount: yup
      .string()
      .required(
        t('fieldIsARequiredField', {
          field: t('paymentLimits.amountLabel'),
          interpolation: { escapeValue: false },
        })
      )
      .matches(AMOUNT_VALIDATION_PATTERN, t('formFields.errors.invalidAmount')),
  })
}
